import { getFdicBannerList, getActiveLocale } from './selectors';

export const showFdicBanner = (store) => {
  const state = store.getState();
  const fdicBannerList = getFdicBannerList(state).toJS();
  const activeLocale = getActiveLocale(state).toLowerCase();
  const showFdic = fdicBannerList && fdicBannerList.includes(activeLocale);
  return showFdic;
};
